import edit from "./edit";
import save from "./save";
import block from "./block.json";
import { createBlock } from '@wordpress/blocks';
import { __ } from "@wordpress/i18n";
import { registerBlockType } from "@wordpress/blocks";

/**
 * Register Block
 */
registerBlockType(block, {
  edit,
  save,
  transforms: {
		from: [
			{
				type: 'block',
				blocks: ['core/heading'],
				transform: ({level, content}) => {
					return createBlock("neodigital/kicker-headline", {
						headlineLevel: level,
                        headline: content?.text,
					});
				},
			},
		],
		to: [
			{
				type: 'block',
				blocks: ['core/heading'],
				transform: ({headline, headlineLevel, textAlign}) => {
					return createBlock('core/heading', {
						content: headline || '',
						level: headlineLevel || 2,
						textAlign: textAlign || '',
					});
				},
			},
		],
	},
});
